import { Badge2 } from "@/ui2/atoms/Badge";
import type { UUID } from "@/core/types";

import { IdentityDocumentPreviewButton } from "./IdentityDocumentPreviewButton";

type IdentityDocumentEditModeProps = {
  entityId?: never;
  isDisabled: true;
  personalIdFront?: string;
};

type IdentityDocumentViewModeProps = {
  entityId: UUID;
  isDisabled?: never;
  personalIdFront?: string;
};

type IdentityDocumentProps = IdentityDocumentEditModeProps | IdentityDocumentViewModeProps;

export function IdentityDocument({ entityId, isDisabled, personalIdFront }: IdentityDocumentProps) {
  const isUploaded = Boolean(personalIdFront);

  return (
    <dl className="tw:flex tw:flex-col tw:gap-2 tw:text-sm">
      <dt className="tw:font-bold">Identity Document</dt>
      <dd className="tw:mb-0!">
        {isUploaded ? (
          <IdentityDocumentPreviewButton entityId={entityId} isDisabled={isDisabled} />
        ) : (
          <Badge2 variant="outline-neutral">Not Uploaded</Badge2>
        )}
      </dd>
    </dl>
  );
}
